"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var feature_discovery_component_1 = require("./feature-discovery.component");
var MzFeatureDiscoveryModule = (function () {
    function MzFeatureDiscoveryModule() {
    }
    return MzFeatureDiscoveryModule;
}());
MzFeatureDiscoveryModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [
                    common_1.CommonModule,
                ],
                declarations: [
                    feature_discovery_component_1.MzFeatureDiscoveryComponent,
                ],
                exports: [
                    feature_discovery_component_1.MzFeatureDiscoveryComponent,
                ],
            },] },
];
/** @nocollapse */
MzFeatureDiscoveryModule.ctorParameters = function () { return []; };
exports.MzFeatureDiscoveryModule = MzFeatureDiscoveryModule;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/feature-discovery/feature-discovery.module.js
// module id = ./node_modules/ng2-materialize/dist/feature-discovery/feature-discovery.module.js
// module chunks = vendor